import Card from './src/card2.mjs';
export { cardContextKey, cardProps } from './src/card.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCard = withInstall(Card);

export { ElCard, ElCard as default };
//# sourceMappingURL=index.mjs.map
